// extracted by mini-css-extract-plugin
export default {"root":"VMCgC9SLr37ZMcCjaDtA","certificate-chains":"WA1sgBkcoZRhaKLryxPX"};